import { arrayToObject } from '@hotglue/common';

const defaultState = {
  supported: {},
  linked: undefined,
  selectedConnector: undefined,
  selectedStream: undefined,
  fieldMapSelection: undefined,
  linkedList: [],
  status: undefined,
  primaryKeys: []
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type, params } = action;

  switch (type) {
    case 'SET_CONNECTOR_PRIMARY_KEYS':
      newState.primaryKeys = payload
      return newState
    case 'SELECT_STREAM_CONNECTOR':
      newState.selectedStream = payload;
      return newState;
    case 'SET_FIELD_MAP_CONNECTOR':
      const { id } = params;

      if (params.stream) {
        const { stream } = params;
        newState.linked[id].fieldMap[stream] = payload;
        return newState;
      }

      newState.linked[id].fieldMap = payload;
      return newState;

    case 'UPDATE_LINKED_CONNECTOR':
      if (status == 'error') newState.error = 'error';
      if (status == 'success') {
        const { connectorId, fieldMap } = params;

        if (fieldMap)
          newState.linked[connectorId] = { ...newState.linked[connectorId], fieldMap };
      }
      return newState;

    //   return newState;
    case 'SET_TENANT':
    case 'CLEAR_CONNECTORS':
      newState.linked = undefined;
      newState.selectedConnector = undefined;
      newState.selectedStream = undefined;

      return newState;

    case 'FETCH_SUPPORTED_CONNECTORS':
      const { flowId } = params;
      if (status == 'success') newState.supported[flowId] = arrayToObject(payload, 'id');
      return newState;

    case 'FETCH_LINKED_CONNECTORS':
      newState.status = status;
      if (status == 'success') {
        const { tenantId } = params
        const filteredPayload = tenantId ? payload.filter(connector => connector.tenant_id === tenantId) : payload
        newState.linked = arrayToObject(filteredPayload, 'id');
        newState.linkedList = payload;
      }
      return newState;

    case 'ADD_LINKED_CONNECTOR':
      if (status == 'success' && params.connector) newState.linked = { [params.connector.id]: params.connector };
      return newState;

    case 'FETCH_LINKED_CONNECTOR':
      newState.status = status;
      if (status == 'success') {
        newState.linked = arrayToObject(payload, 'id');
        if (newState.linkedList.length > 0 && payload.length === 1) {
          const index = newState.linkedList.findIndex(x => x.tenant_id === payload[0].tenant_id)
          if (index >= 0)
            newState.linkedList[index] = payload[0]
        } else {
          newState.linkedList = payload
        };
      };
      return newState;

    case 'UNLINK_CONNECTOR':
      if (status == 'success' && newState.linked !== undefined) {
        delete newState.linked[params.connectorId];
      }
      return newState;

    case 'SELECT_CONNECTOR':
      newState.selectedConnector = payload;
      return newState;

    case 'SET_FIELD_MAP_SELECTION_CONNECTOR':
      const { stream } = params;
      if (stream) newState.fieldMapSelection[stream] = { ...newState.fieldMapSelection[stream], ...payload };
      else newState.fieldMapSelection = payload;
      return newState;

    case 'CLEAR_FIELD_MAP_SELECTION_CONNECTOR':
      newState.fieldMapSelection = undefined;
      return newState;
  }

  return state;
};
